const bossError = 'BossError';

export const CHANGE_USER_AND_PROJECT = `${bossError}/CHANGE_USER_AND_PROJECT`;
